module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTI3IDI1My41IDUwMS42IDgxNSA5NzYuMiAyNTMuNSA5NDEgMjIzLjggNTAxLjYgNzQzLjcgNjIuMiAyMjMuOFoiIHAtaWQ9IjEwODMiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/tobottom.svg
// module id = GMhT
// module chunks = 75